import React, { useContext } from "react";
import { useMutation } from "@apollo/client";

import { UserSettings } from "../../../models/user";
import { DataContext } from "../../../context/data-context";
import Appearance from "../settings/appearance";
import { SETPREFF } from "../profile/queries";
import { LangItem } from "../../../models/lang";
import { SETLANG } from "../../layouts/queries";
type StudentSettingsProps = {
  settings: UserSettings;
  setSettings: React.Dispatch<React.SetStateAction<UserSettings>>;
  langs?: LangItem[];
};
const StudentSettings: React.FC<StudentSettingsProps> = ({
  settings,
  setSettings,
  langs,
}) => {
  const [setLang, { loading: loadingupdate }] = useMutation(SETLANG);
  const dataContext = useContext(DataContext);
  const [setPreff] = useMutation(SETPREFF);
  const handleUpdateSetting = (setting: keyof UserSettings, value: any) => {
    const set_settings = { ...settings, [setting]: value };
    setSettings(set_settings);
    ///run mutation to update settings
    setPreff({
      variables: {
        pref_value: value.toString(),
        pref_key: setting,
        is_global: false,
      },
    });
    if (dataContext.setSettings) {
      dataContext.setSettings(set_settings);
    }
  };

  const updateLangPref = async (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selected_lang_id = parseInt(e.target.value);
    console.log("student_settings.tsx:42 | selected_lang_id", selected_lang_id);

    setLang({ variables: { lang_id: selected_lang_id } });
    dataContext.setLang(e.target.value, false);
  };
  return (
    <div>
      <Appearance setSettings={handleUpdateSetting} />
      {langs && (
        <div className="form-group my-3">
          <label htmlFor="plan_id" className="text-white">
            Change Active Language
          </label>
          <select
            className="form-control"
            value={dataContext.user ? dataContext.user.lang_id : ""}
            onChange={updateLangPref}
            disabled={loadingupdate}
          >
            {langs.map((item) => (
              <option value={item.id} key={`langs.map_${item.name}`}>
                {item.name}
              </option>
            ))}
          </select>
          <small className="text-muted">
            This will change the language of the books in your library.
          </small>
        </div>
      )}
    </div>
  );
};

export default StudentSettings;
